import { withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id", "checked", "value"]
const _hoisted_2 = ["tabindex", "aria-label", "aria-checked", "aria-labelledby"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["tabindex"]
const _hoisted_5 = ["tabindex"]
const _hoisted_6 = {
  key: 0,
  class: "checkbox-outer-container-description"
}
const _hoisted_7 = { class: "checkbox-outer-container-extra" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")!
  const _directive_clean_tooltip = _resolveDirective("clean-tooltip")!
  const _directive_stripped_aria_label = _resolveDirective("stripped-aria-label")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["checkbox-outer-container", {
      'v-popper--has-tooltip': _ctx.hasTooltip,
    }]),
    "data-checkbox-ctrl": ""
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["checkbox-container", { 'disabled': _ctx.isDisabled}]),
      onKeydown: [
        _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.clicked($event)), ["prevent"]), ["enter"])),
        _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.clicked($event)), ["prevent"]), ["space"]))
      ],
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clicked($event)))
    }, [
      _createElementVNode("input", {
        id: _ctx.id,
        checked: _ctx.isChecked,
        value: _ctx.valueWhenTrue,
        type: "checkbox",
        tabindex: "-1",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["stop","prevent"]), ["enter"]))
      }, null, 40, _hoisted_1),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createElementVNode("span", {
        class: _normalizeClass(["checkbox-custom", {indeterminate: _ctx.indeterminate}]),
        tabindex: _ctx.isDisabled ? -1 : 0,
        "aria-label": _ctx.replacementLabel,
        "aria-checked": !!_ctx.value,
        "aria-labelledby": _ctx.labelKey || _ctx.label ? _ctx.idForLabel : undefined,
        role: "checkbox"
      }, null, 10, _hoisted_2),
      _cache[7] || (_cache[7] = _createTextVNode()),
      (_ctx.$slots.label || _ctx.label || _ctx.labelKey || _ctx.hasTooltip)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["checkbox-label", { 'checkbox-primary': _ctx.primary }])
          }, [
            _renderSlot(_ctx.$slots, "label", {}, () => [
              (_ctx.labelKey)
                ? (_openBlock(), _createBlock(_component_t, {
                    key: 0,
                    id: _ctx.idForLabel,
                    k: _ctx.labelKey,
                    raw: true
                  }, null, 8, ["id", "k"]))
                : (_ctx.label)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      id: _ctx.idForLabel
                    }, _toDisplayString(_ctx.label), 9, _hoisted_3))
                  : _createCommentVNode("", true),
              _cache[5] || (_cache[5] = _createTextVNode()),
              (_ctx.tooltipKey)
                ? _withDirectives((_openBlock(), _createElementBlock("i", {
                    key: 2,
                    class: "checkbox-info icon icon-info icon-lg",
                    tabindex: _ctx.isDisabled ? -1 : 0
                  }, null, 8, _hoisted_4)), [
                    [_directive_clean_tooltip, {content: _ctx.t(_ctx.tooltipKey), triggers: ['hover', 'touch', 'focus']}],
                    [_directive_stripped_aria_label, _ctx.t(_ctx.tooltipKey)]
                  ])
                : (_ctx.tooltip)
                  ? _withDirectives((_openBlock(), _createElementBlock("i", {
                      key: 3,
                      class: "checkbox-info icon icon-info icon-lg",
                      tabindex: _ctx.isDisabled ? -1 : 0
                    }, null, 8, _hoisted_5)), [
                      [_directive_clean_tooltip, {content: _ctx.tooltip, triggers: ['hover', 'touch', 'focus']}],
                      [_directive_stripped_aria_label, _ctx.tooltip]
                    ])
                  : _createCommentVNode("", true)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ], 34),
    _cache[8] || (_cache[8] = _createTextVNode()),
    (_ctx.descriptionKey || _ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.descriptionKey)
            ? (_openBlock(), _createBlock(_component_t, {
                key: 0,
                k: _ctx.descriptionKey
              }, null, 8, ["k"]))
            : (_ctx.description)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.description), 1)
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createTextVNode()),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "extra")
    ])
  ], 2))
}